import Vue from 'vue'
import Router from 'vue-router'
import mall from './modules/mall'
import mallOrder from './modules/mall-order'
import information from './modules/information'
import workOrder from './modules/work-order'
import insuranceClaims from './modules/insurance-claims'
import customer from './modules/customer'
import feedBack from './modules/feedback'
import finance from './modules/finance'
import otherPolicy from './modules/other-service'
import newToOldAudit from './modules/new-to-old-audit'
import appointmentApplication from './modules/appointment-application'
import obsDepartment from './modules/obs-department'
import mallOfIntegral from './modules/mall-of-integral'
import linkManage from './modules/link-manage'
import famousDoctorHall from './modules/famous-doctor-hall'
Vue.use(Router)
// 定义路由规则
let router = new Router({
  mode: 'history',
  routes: [
    ...mall,
    ...mallOrder,
    ...information,
    ...workOrder,
    ...insuranceClaims,
    ...customer,
    ...finance,
    ...feedBack,
    ...otherPolicy,
    ...newToOldAudit,
    ...appointmentApplication,
    ...mallOfIntegral,
    ...linkManage,
    ...obsDepartment,
    ...famousDoctorHall,
    {
      path: '/',
      name: 'home',
      component: resolve => require(['views/Home'], resolve),
      meta: { auth: true, view: 'pc' }
    },
    {
      path: '/404',
      redirect: '/',
      name: 'home',
      component: resolve => require(['views/Home'], resolve),
      meta: { auth: true, view: 'pc' }
    },
    {
      path: '/login',
      name: 'login',
      component: resolve => require(['views/login'], resolve),
      meta: { auth: false, view: 'defaultView' }
    },
    {
      path: '/order-new',
      name: 'order-new',
      component: resolve => require(['views/order-new'], resolve),
      meta: { auth: true, view: 'pc' }
    },
    {
      path: '/lot-list',
      name: 'lot-list',
      component: resolve => require(['views/lot-list'], resolve),
      meta: { auth: true, view: 'pc' }
    },
    // { permissions: ['PERM_CONSOLE_OPERATE',"PERM_SWAGGER"], redirect: '/home' }
    {
      path: '/gene-lab-order',
      name: 'gene-lab-order',
      component: resolve => require(['views/gene-lab-order'], resolve),
      meta: { auth: true, view: 'pc' }
    },
    {
      path: '/gene-report-order/:status',
      name: 'gene-report-order',
      props: true,
      component: resolve => require(['views/gene-report-order'], resolve),
      meta: { auth: true, view: 'pc' }
    },
    {
      path: '/lab-order-detail/:id',
      name: 'lab-order-detail',
      props: true,
      component: resolve => require(['views/lab-order-detail'], resolve),
      meta: { auth: true, view: 'pc', navInfo: '基因实验室订单/订单详情' }
    },
    {
      path: '/lab-order-lot-operate/:status',
      name: 'lab-order-lot-operate',
      props: true,
      component: resolve => require(['views/lab-order-lot-operate'], resolve),
      meta: { auth: true, view: 'pc' }
    },
    {
      path: '/order-handle/:status',
      name: 'order-handle',
      props: true,
      component: resolve => require(['views/order-handle'], resolve),
      meta: { auth: true, view: 'pc', navInfo: '基因实验室订单/订单处理' }
    },
    {
      path: '/business-order-lot-new',
      name: 'business-order-lot-new',
      component: resolve => require(['views/business-order-lot-new'], resolve),
      meta: { auth: true, view: 'pc', navInfo: '实验室订单/批量创建订单' }
    },
    {
      path: '/gene-report-apply-list',
      name: 'gene-report-apply-list',
      component: resolve => require(['views/gene-report-apply-list'], resolve),
      meta: { auth: true, view: 'pc' }
    },
    {
      path: '/create-report-unscramble-apply',
      name: 'create-report-unscramble-apply',
      component: resolve => require(['views/create-report-unscramble-apply'], resolve),
      meta: { auth: true, view: 'pc' }
    },
    {
      path: '/report-unscramble-apply-list',
      name: 'report-unscramble-apply-list',
      component: resolve => require(['views/report-unscramble-apply-list'], resolve),
      meta: { auth: true, view: 'pc' }
    },
    {
      path: '/detection-list',
      name: 'detection-list',
      component: resolve => require(['views/detection-list'], resolve),
      meta: { auth: true, view: 'pc' }
    },
    {
      path: '/lab-test-platform-list',
      name: 'lab-test-platform-list',
      component: resolve => require(['views/lab-test-platform-list'], resolve),
      meta: { auth: true, view: 'pc' }
    },
    {
      path: '/lab-test-platform-new',
      name: 'lab-test-platform-new',
      component: resolve => require(['views/lab-test-platform-new'], resolve),
      meta: { auth: true, view: 'pc', navInfo: '基因实验室检测平台/新建基因实验室检测平台' }
    },
    {
      path: '/detection-new',
      name: 'detection-new',
      component: resolve => require(['views/detection-new'], resolve),
      meta: { auth: true, view: 'pc', navInfo: '基因检测项/新建检测项' }
    },
    {
      path: '/detection-corpus-list',
      name: 'detection-corpus-list',
      component: resolve => require(['views/detection-corpus-list'], resolve),
      meta: { auth: true, view: 'pc' }
    },
    {
      path: '/detection-corpus-structure-list',
      name: 'detection-corpus-structure-list',
      component: resolve => require(['views/detection-corpus-structure-list'], resolve),
      meta: { auth: true, view: 'pc' }
    },
    {
      path: '/detection-corpus-new',
      name: 'detection-corpus-new',
      component: resolve => require(['views/detection-corpus-new'], resolve),
      meta: { auth: true, view: 'pc', navInfo: '检测项知识库/新建检测项知识库' }
    },
    {
      path: '/lab-test-platform-update/:id',
      name: 'lab-test-platform-update',
      props: true,
      component: resolve => require(['views/lab-test-platform-update'], resolve),
      meta: { auth: true, view: 'pc', navInfo: '基因实验室检测平台/编辑基因实验室检测平台' }
    },
    {
      path: '/detection-corpus-structure-new',
      name: 'detection-corpus-structure-new',
      component: resolve => require(['views/detection-corpus-structure-new'], resolve),
      meta: { auth: true, view: 'pc', navInfo: '知识库结构管理/新建知识库结构' }
    },
    {
      path: '/detection-corpus-structure-update/:id',
      name: 'detection-corpus-structure-update',
      props: true,
      component: resolve => require(['views/detection-corpus-structure-update'], resolve),
      meta: { auth: true, view: 'pc', navInfo: '知识库结构管理/编辑知识库结构' }
    },
    {
      path: '/detection-corpus-detail/:id',
      name: 'detection-corpus-detail',
      props: true,
      component: resolve => require(['views/detection-corpus-detail'], resolve),
      meta: { auth: true, view: 'pc', navInfo: '检测项知识库/知识库详情' }
    },
    {
      path: '/detection-corpus-update/:id',
      name: 'detection-corpus-update',
      props: true,
      component: resolve => require(['views/detection-corpus-update'], resolve),
      meta: { auth: true, view: 'pc', navInfo: '检测项知识库/编辑知识库' }
    },
    {
      path: '/detection-update/:category/:id',
      name: 'detection-update',
      props: true,
      component: resolve => require(['views/detection-update'], resolve),
      meta: { auth: true, view: 'pc', navInfo: '基因检测项/编辑检测项' }
    },
    {
      path: '/detection-detail/:id',
      name: 'detection-detail',
      props: true,
      component: resolve => require(['views/detection-detail'], resolve),
      meta: { auth: true, view: 'pc', navInfo: '基因检测项/检测项详情' }
    },
    {
      path: '/detection-package-list',
      name: 'detection-package-list',
      component: resolve => require(['views/detection-package-list'], resolve),
      meta: { auth: true, view: 'pc' }
    },
    {
      path: '/detection-package-detail/:id',
      name: 'detection-package-detail',
      props: true,
      component: resolve => require(['views/detection-package-detail'], resolve),
      meta: { auth: true, view: 'pc', navInfo: '基因检测套餐/基因检测套餐详情' }
    },
    {
      path: '/detection-package-new',
      name: 'detection-package-new',
      component: resolve => require(['views/detection-package-new'], resolve),
      meta: { auth: true, view: 'pc', navInfo: '基因检测套餐/新建基因检测套餐' }
    },
    {
      path: '/detection-package-update/:id',
      name: 'detection-package-update',
      props: true,
      component: resolve => require(['views/detection-package-update'], resolve),
      meta: { auth: true, view: 'pc', navInfo: '基因检测套餐/编辑基因检测套餐' }
    },
    {
      path: '/show-calculate-result/:jobId',
      name: 'show-calculate-result',
      props: true,
      component: resolve => require(['views/show-calculate-result'], resolve),
      meta: { auth: true, view: 'pc' }
    },
    {
      path: '/customer-sample-list',
      name: 'customer-sample-list',
      component: resolve => require(['views/customer-sample-list'], resolve),
      meta: { auth: true, view: 'pc' }
    },
    {
      path: '/test',
      name: 'test',
      component: resolve => require(['views/test'], resolve),
      meta: { auth: true, view: 'pc' }
    },
    {
      path: '/classify-table',
      name: 'classify-table',
      component: resolve => require(['views/classify-table'], resolve),
      meta: { auth: true, view: 'pc' }
    },
    // 咨询师模块
    {
      path: '/counselor-manage',
      name: 'counselor-manage',
      component: resolve => require(['views/counselor-manage'], resolve),
      meta: { auth: true, view: 'pc' }
    },
    {
      path: '/pt-counselor-detail/:id',
      name: 'counselor-detail',
      props: true,
      component: resolve => require(['views/counselor-detail'], resolve),
      meta: { auth: true, view: 'pc', navInfo: '咨询师/咨询师详情' }
    },
    {
      path: '/counselor-form/:isEdit/:id',
      name: 'counselor-form',
      props: true,
      component: resolve => require(['views/counselor-form'], resolve),
      meta: { auth: true, view: 'pc', navInfo: '咨询师/咨询师', isForm: true }
    },
    {
      path: '/cps-payment',
      name: 'cps-payment',
      component: resolve => require(['views/cps-payment'], resolve),
      meta: { auth: true, view: 'pc' }
    },
    {
      path: '/export-history/mall_order_bill',
      name: 'export-history',
      component: resolve => require(['views/export-history'], resolve),
      meta: { auth: true, view: 'pc', navInfo: 'CPS缴费记录/CPS缴费记录导出历史' }
    },
    {
      path: '/edit-password',
      name: 'edit-password',
      component: resolve => require(['views/edit-password'], resolve),
      meta: { auth: true, view: 'pc' }
    },
    {
      path: '/debug/ueditor',
      name: 'ueditor',
      component: resolve => require(['views/debug/ueditor'], resolve),
      meta: { auth: true, view: 'pc' }
    },
    {
      path: '/lab-order-form/:isEdit/:id',
      name: 'lab-order-form',
      component: resolve => require(['views/lab-order-form'], resolve),
      meta: { auth: true, view: 'pc', navInfo: '实验室订单/订单', isForm: true }
    },
    {
      path: '/export-history',
      props: true,
      name: 'export-history',
      component: resolve => require(['views/export-history'], resolve),
      meta: { auth: true, view: 'pc' }
    },
    {
      path: '/export-history/lab-order',
      name: 'export-history',
      component: resolve => require(['views/export-history'], resolve),
      meta: { auth: true, view: 'pc', navInfo: '基因实验室订单/实验室订单导出历史' }
    },
    {
      path: '/branch-company',
      name: 'branch-company',
      component: resolve => require(['views/branch-company'], resolve),
      meta: { auth: true, view: 'pc' }
    },
    {
      path: '/branch-company-table',
      name: 'branch-company-table',
      component: resolve => require(['views/branch-company-table'], resolve),
      meta: { auth: true, view: 'pc' }
    },
    {
      path: '/branch-company-detail/:id',
      name: 'branch-company-detail',
      component: resolve => require(['views/branch-company-detail'], resolve),
      meta: { auth: true, view: 'pc', navInfo: '分/子公司管理/分子公司详情' }
    },
    {
      path: '/branch-company/branch-company-form/:isEdit/:id',
      props: true,
      name: 'branch-company-form',
      component: resolve => require(['views/branch-company-form'], resolve),
      meta: { auth: true, view: 'pc', navInfo: '分/子公司管理/分/子公司', isForm: true }
    },
    {
      path: '/doctor-manage',
      name: 'doctor-manage',
      component: resolve => require(['views/doctor-manage'], resolve),
      meta: { auth: true, view: 'pc' }
    },
    {
      path: '/hospital-manage',
      name: 'hospital-manage',
      component: resolve => require(['views/hospital-manage'], resolve),
      meta: { auth: true, view: 'pc' }
    },
    {
      path: '/doctor-table',
      name: 'doctor-table',
      component: resolve => require(['views/doctor-table'], resolve),
      meta: { auth: true, view: 'pc' }
    },
    {
      path: '/doctor-detail/:id',
      name: 'doctor-detail',
      component: resolve => require(['views/doctor-detail'], resolve),
      meta: { auth: true, view: 'pc', navInfo: '医生管理/医生详情' }
    },
    {
      path: '/doctor-manage/doctor-form/:isEdit/:id',
      props: true,
      name: 'doctor-form',
      component: resolve => require(['views/doctor-form'], resolve),
      meta: { auth: true, view: 'pc', navInfo: '医生管理/医生', isForm: true }
    },
    {
      path: '/hospital-table',
      name: 'hospital-table',
      component: resolve => require(['views/hospital-table'], resolve),
      meta: { auth: true, view: 'pc' }
    },
    {
      path: '/hospital-detail/:id',
      name: 'hospital-detail',
      component: resolve => require(['views/hospital-detail'], resolve),
      meta: { auth: true, view: 'pc', navInfo: '医院管理/医院详情' }
    },
    {
      path: '/hospital-manage/hospital-form/:isEdit/:id',
      props: true,
      name: 'hospital-form',
      component: resolve => require(['views/hospital-form'], resolve),
      meta: { auth: true, view: 'pc', navInfo: '医院管理/医院', isForm: true }
    },
    {
      path: '/adult-sell-order',
      name: 'adult-sell-order',
      component: resolve => require(['views/adult-sell-order'], resolve),
      meta: { auth: true, view: 'pc' }
    },
    {
      path: '/adult-sell-order-table',
      name: 'adult-sell-order-table',
      component: resolve => require(['views/adult-sell-order-table'], resolve),
      meta: { auth: true, view: 'pc' }
    },
    {
      path: '/adult-sell-order-form',
      name: 'adult-sell-order-form',
      component: resolve => require(['views/adult-sell-order-form'], resolve),
      meta: { auth: true, view: 'pc' }
    },
    {
      path: '/sell-operate-choice-dialog',
      name: 'sell-operate-choice-dialog',
      component: resolve => require(['views/sell-operate-choice-dialog'], resolve),
      meta: { auth: true, view: 'pc' }
    },
    {
      path: '/sell-order-form/:isEdit/:id',
      name: 'sell-order-form',
      component: resolve => require(['views/sell-order-form'], resolve),
      meta: { auth: true, view: 'pc', navInfo: '成人实验室订单/订单', isForm: true }
    },
    {
      path: '/adult-sell-order-detail/:id',
      name: 'adult-sell-order-detail',
      props: true,
      component: resolve => require(['views/adult-sell-order-detail'], resolve),
      meta: { auth: true, view: 'pc', navInfo: '成人实验室订单/订单详情' }
    },
    {
      path: '/adult-sell-order-progress',
      name: 'adult-sell-order-progress',
      component: resolve => require(['views/adult-sell-order-progress'], resolve),
      meta: { auth: true, view: 'pc' }
    },
    {
      path: '/adult-sell-order-handle/:status',
      name: 'adult-sell-order-handle',
      component: resolve => require(['views/adult-sell-order-handle'], resolve),
      meta: { auth: true, view: 'pc' }
    },
    {
      path: '/adult-sell-order-handle-table',
      name: 'adult-sell-order-handle-table',
      component: resolve => require(['views/adult-sell-order-handle-table'], resolve),
      meta: { auth: true, view: 'pc' }
    },
    {
      path: '/batch-operation',
      name: 'batch-operation',
      component: resolve => require(['views/batch-operation'], resolve),
      meta: { auth: true, view: 'pc' }
    },
    {
      path: '/batch-operation-form',
      name: 'batch-operation-form',
      component: resolve => require(['views/batch-operation-form'], resolve),
      meta: { auth: true, view: 'pc' }
    },
    {
      path: '/export-history/adult-lab-order',
      name: 'adult_lab_order',
      component: resolve => require(['views/export-history'], resolve),
      meta: { auth: true, view: 'pc', navInfo: '成人实验室订单/成人实验室订单导出历史' }
    },
    {
      path: '/adult-stock-list/:status',
      name: 'adult-stock-list',
      component: resolve => require(['views/adult-stock-list'], resolve),
      meta: { auth: true, view: 'pc', navInfo: '库存管理/库存管理' }
    },
    {
      path: '/adult-out-stock',
      name: 'adult-out-stock',
      component: resolve => require(['views/adult-out-stock'], resolve),
      meta: { auth: true, view: 'pc' }
    },
    {
      path: '/holiday-manage/gene',
      props: true,
      name: 'holiday-manage-gene',
      component: resolve => require(['views/holiday-manage'], resolve),
      meta: { auth: true, view: 'pc', type: 'gene' }
    },
    {
      path: '/holiday-manage/adult',
      name: 'holiday-manage-adult',
      component: resolve => require(['views/holiday-manage'], resolve),
      meta: { auth: true, view: 'pc', type: 'adult' }
    },
    {
      path: '/holiday-manage/adult/holiday-form/:isEdit/:id',
      props: true,
      name: 'holiday-form-adult',
      component: resolve => require(['views/holiday-form'], resolve),
      meta: { auth: true, view: 'pc', navInfo: '节假日管理(成人)/节假日(成人)', type: 'adult', isForm: true }
    },
    {
      path: '/holiday-manage/gene/holiday-form/:isEdit/:id',
      props: true,
      name: 'holiday-form-gene',
      component: resolve => require(['views/holiday-form'], resolve),
      meta: { auth: true, view: 'pc', navInfo: '节假日管理(基因)/节假日(基因)', type: 'gene', isForm: true }
    },
    {
      path: '/holiday-excel-new/gene',
      props: true,
      name: 'holiday-excel-new-gene',
      component: resolve => require(['views/holiday-excel-new'], resolve),
      meta: { auth: true, view: 'pc', navInfo: '节假日管理(基因)/批量导入节假日(基因)', type: 'gene' }
    },
    {
      path: '/holiday-excel-new/adult',
      props: true,
      name: 'holiday-excel-new-adult',
      component: resolve => require(['views/holiday-excel-new'], resolve),
      meta: { auth: true, view: 'pc', navInfo: '节假日管理(成人)/批量导入节假日(成人)', type: 'adult' }
    },
    {
      path: '/export-history/doctor-qr-code',
      name: 'doctor-qr-code-history',
      component: resolve => require(['views/export-history'], resolve),
      meta: { auth: true, view: 'pc', navInfo: '医生管理/医生导出历史' }
    },
    {
      path: '/post-manage',
      name: 'post-manage',
      component: resolve => require(['views/post-manage'], resolve),
      meta: { auth: true, view: 'pc' }
    },
    {
      path: '/post-manage/poster-form/:isEdit/:id',
      name: 'poster-form',
      props: true,
      component: resolve => require(['views/poster-form'], resolve),
      meta: { auth: true, view: 'pc', navInfo: '海报管理/海报', isForm: true }
    },
    {
      path: '/poster-detail/:id',
      name: 'poster-detail',
      props: true,
      component: resolve => require(['views/poster-detail'], resolve),
      meta: { auth: true, view: 'pc', navInfo: '海报管理/海报详情' }
    },
    {
      path: '/poster-review/:status',
      name: 'poster-review',
      props: true,
      component: resolve => require(['views/poster-review'], resolve),
      meta: { auth: true, view: 'pc' }
    },
    {
      path: '/order-form',
      name: 'order-form',
      component: resolve => require(['views/order-form'], resolve),
      meta: { auth: true, view: 'pc', navInfo: '销售订单/创建订单' }
    },
    {
      path: '/video-manage',
      name: 'video-manage',
      component: resolve => require(['views/video-manage'], resolve),
      meta: { auth: true, view: 'pc' }
    },
    {
      path: '/video-review/:status',
      name: 'video-review',
      component: resolve => require(['views/video-review'], resolve),
      meta: { auth: true, view: 'pc' }
    },
    {
      path: '/video-manage/video-form/:isEdit/:id',
      name: 'video-form',
      props: true,
      component: resolve => require(['views/video-form'], resolve),
      meta: { auth: true, view: 'pc', navInfo: '视频管理/视频', isForm: true }
    },
    {
      path: '/video-detail/:id',
      name: 'video-detail',
      props: true,
      component: resolve => require(['views/video-detail'], resolve),
      meta: { auth: true, view: 'pc', navInfo: '视频管理/视频详情' }
    },
    {
      path: '/balance-detail/:id',
      name: 'balance-detail',
      component: resolve => require(['views/balance-detail'], resolve),
      meta: { auth: true, view: 'pc', navInfo: '账户额度管理/账户额度管理详情' }
    },
    {
      path: '/refund-integral-audit',
      name: 'refund-integral-audit',
      component: resolve => require(['views/refund-integral-audit'], resolve),
      meta: { auth: true, view: 'pc' }
    },
    {
      path: '/deposit-settlement',
      name: 'deposit-settlement',
      component: resolve => require(['views/deposit-settlement'], resolve),
      meta: { auth: true, view: 'pc' }
    },
    {
      path: '/integral-particulars',
      name: 'integral-particulars',
      component: resolve => require(['views/integral-particulars'], resolve),
      meta: { auth: true, view: 'pc' }
    },
    {
      path: '/points-reward-detail/:id',
      name: 'points-reward-detail',
      component: resolve => require(['views/points-reward-detail'], resolve),
      meta: { auth: true, view: 'pc', navInfo: '手动发放积分/手动发放积分详情' }
    },
    {
      path: '/assigned-tasks-form/:id/:recordId',
      name: 'assigned-tasks-form',
      component: resolve => require(['views/assigned-tasks-form'], resolve),
      meta: { auth: true, view: 'pc' }
    },
    {
      path: '/20th-anniversary-sign',
      name: 'anniversary-active-sign',
      component: resolve => require(['views/anniversary-active-sign'], resolve),
      meta: { auth: true, view: 'pc' }
    },
    {
      path: '/scan-payment',
      name: 'scan-payment',
      component: resolve => require(['views/scan-payment'], resolve),
      meta: { auth: true, view: 'pc' }
    },
    {
      path: '/insure-material',
      name: 'insure-info',
      component: resolve => require(['views/insure-info'], resolve),
      meta: { auth: true, view: 'pc' }
    },
    {
      path: '/insure-info-detail/:id',
      name: 'insure-info-detail',
      component: resolve => require(['views/insure-info-detail'], resolve),
      meta: { auth: true, view: 'pc', navInfo: '投保信息/投保信息详情' }
    },
    {
      path: '/export-history/insure-material',
      props: true,
      name: 'export-history-insure',
      component: resolve => require(['views/export-history'], resolve),
      meta: { auth: true, view: 'pc', navInfo: '投保信息/投保信息导出历史' }
    },
    {
      path: '/scan-payment',
      name: 'scan-payment',
      component: resolve => require(['views/scan-payment'], resolve),
      meta: { auth: true, view: 'pc' }
    },
    {
      path: '/export-history/counselor-qr-code',
      name: 'counselor-qr-code',
      component: resolve => require(['views/export-history'], resolve),
      meta: { auth: true, view: 'pc', navInfo: '咨询师管理/导出历史' }
    },
    {
      path: '/insure-info-form/:id',
      name: 'insure-info-form',
      component: resolve => require(['views/insure-info-form'], resolve),
      meta: { view: 'pc', navInfo: '投保信息/编辑投保' }
    }
  ]
})
/*
 * 路由拦截，每次路劲切换时触发，一般用来进行权限判定，更多使用方式参见vue-router导航钩子
 * to: 跳转目标的路由对象
 * from：跳转前的路由对象
 * next: 如果需要拦截跳转，则用next(false),否则用next()
 */
router.beforeEach((to, from, next) => {
  next()
  // Vue.prototype.$auth.fetch({
  //   params: {},
  //   success: function (data) {
  //   },
  //   error: function () {}
  //   // etc...
  // })
  // if (to.meta.auth) {
  // 先判断是否已登录，没登录的话，跳转到登录界面
  // 尝试获取下用户数据，如果能获取到，则表明存在有效的cookie，直接静默登录
  // 如果获取失败，则表明用户未登录过，过cookie过期，需要登录
  // console.log('data-----------------------', Vue.prototype.$auth.user())
  // Vue.prototype.$auth.fetch({
  //   ...Vue.prototype.$auth.options.fetchData, // 解构/auth/config.js里配置的fetchData
  //   success (data) {
  //     // 判断访问该路由时，当前用户是否必须先通过后台认证
  //     console.log('data-----------------------', data)
  //     if (Vue.prototype.$auth.user().doctor.is_valid) {
  //       next()
  //     } else {
  //       Vue.prototype.$toast.info('您的医生信息尚未认证，请等待后台认证后再使用此功能')
  //     }
  //   },
  //   error () {
  //     next({ path: '/login' })
  //   }
  // })
  // } else {
  //   next()
  // }
})
export default router
